var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateTotalBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M19 12.005c0 4.708-3.518 8.593-8 8.995-4.482-.402-8-4.277-8-8.995C3 7.287 6.537 3.381 11.039 3 15.502 3.432 19 7.297 19 12.005z",
    fill: "url(#itunf9f7ya)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3 12c0 4.97 4.94 9 11.032 9 .33 0 .65 0 .968-.04-5.638-.4-10.063-4.27-10.063-8.96 0-4.69 4.425-8.56 10.063-8.96-.319-.03-.637-.04-.968-.04C7.94 3 3 7.03 3 12z",
    fill: "url(#tc0qpzl72b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
    stroke: "url(#5c5v6emgqc)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 7.605A.602.602 0 0 0 12 7c-.331 0-.6.27-.6.605v.681c-1.285.179-2.152 1.003-2.152 2.166v.023c0 1.323.828 1.772 2.152 2.127v1.62a3.794 3.794 0 0 1-1.123-.544.775.775 0 0 0-.484-.153c-.446 0-.793.33-.793.742 0 .247.136.47.322.6l-.024.012c.632.426 1.36.699 2.102.811v.705c0 .334.269.605.6.605.331 0 .6-.27.6-.605v-.663c1.426-.126 2.4-.919 2.4-2.243v-.023c0-1.264-.857-1.795-2.4-2.183V9.767c.298.086.601.22.912.39.137.071.273.118.434.118.447 0 .794-.33.794-.742a.737.737 0 0 0-.372-.635A4.32 4.32 0 0 0 12.6 8.29v-.685zm-1.2 2.13c-.322.105-.49.317-.49.564v.023c0 .287.117.457.49.615V9.734zm1.2 3.197v1.378c.47-.077.739-.313.739-.656v-.023c0-.296-.143-.49-.739-.699z",
    fill: "#C9A87A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "itunf9f7ya",
    x1: 14.872,
    y1: 30.643,
    x2: -1.905,
    y2: 24.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tc0qpzl72b",
    x1: 11.904,
    y1: 30.643,
    x2: -1.304,
    y2: 27.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5c5v6emgqc",
    x1: 16.356,
    y1: 30.643,
    x2: -1.992,
    y2: 23.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateTotalBalance);
export default __webpack_public_path__ + "static/media/corporateTotalBalance.f39d91db4b66aa02e7d7a832ef830006.svg";
export { ForwardRef as ReactComponent };